import { ActionTypes as types } from 'constants';

export default (isLoggedIn = true) => dispatch => {
  dispatch({
    type: types.UPDATE_LOGIN_STATUS,
    payload: { isLoggedIn },
  });
};
